module.exports = __webpack_public_path__ + "img/cartoon.77027a05.webp";